import { render, staticRenderFns } from "./ProductStatusList.vue?vue&type=template&id=38002d40"
import script from "./ProductStatusList.vue?vue&type=script&lang=js"
export * from "./ProductStatusList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports